import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportCreationProfilesComponent } from './component/transport-creation-profiles.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';

import { TableSelectionDialogModule } from 'src/tmc-common/components/table-selection-dialog/table-selection-dialog.module';
import { ApplicationClientCommonModule } from '@sdbn/appclient';

import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from 'src/tmc-yard/components/transport-options-panel/transport-options-panel.module';
import { SelectNumberPlateEntry } from './component/select-number-plates-entry/select-number-plate-entry';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TableSelectionDialogModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    CommonUIModule,
    TransportOptionsPanelModule
  ],
  declarations: [
    TransportCreationProfilesComponent,
    SelectNumberPlateEntry
  ]
})
export class TransportCreationProfilesModule { }

